module.exports = __webpack_public_path__ + "static/media/pcs-pic1.ec80c23e.JPG";